var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCongratulations(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.59184 11.6C4.68367 11.6 3 10 3 7.94286C3 6 4.57143 4.28571 6.59184 4.28571M14.898 16.6286H13.2143C9.62245 16.6286 6.70408 13.6571 6.70408 10V2H21.5204V10C21.4082 13.6571 18.4898 16.6286 14.898 16.6286ZM17.2551 16.1714V20.4H10.8571V16.1714H17.2551ZM22.1939 26H5.91837L8.27551 20.4H19.7245L22.1939 26ZM21.4082 4.28571C23.3163 4.28571 25 5.88571 25 7.94286C25 9.88571 23.4286 11.6 21.4082 11.6V4.28571Z",
    stroke: "#00A862",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCongratulations);
export default __webpack_public_path__ + "static/media/congratulations.b4ba68087ec6de856a2d6a55e2539def.svg";
export { ForwardRef as ReactComponent };